<form [formGroup]="form">
  <div class="inputs">
    <label>Password </label>
    <div caInputContainer [onLightBackground]="onLightBackground">
      <input
        caInput
        [type]="showPassword ? 'text' : 'password'"
        autocomplete="new-password"
        formControlName="newPassword"
        (blur)="onTouched()"
        (input)="onChange($event.target.value)"
      />
      <button
        class="show-password"
        mat-icon-button
        color="primary"
        aria-label="Show password"
        (click)="showPassword = !showPassword"
        type="button"
      >
        <mat-icon>{{
          showPassword ? "visibility" : "visibility_off"
        }}</mat-icon>
      </button>
    </div>
    <div
      [ngClass]="'strengthIndicator passwordStrength_' + (score$ | async)"
    ></div>
    <p class="strengthLabel min-h-4">{{ score$ | async | passwordStrength }}</p>

    <label>Confirm password </label>
    <div caInputContainer [onLightBackground]="onLightBackground">
      <input
        caInput
        [type]="showConfirmPassword ? 'text' : 'password'"
        autocomplete="new-password"
        formControlName="confirmPassword"
        (input)="onTouched()"
      />
      <button
        class="show-password"
        mat-icon-button
        color="primary"
        aria-label="Show password"
        (click)="showConfirmPassword = !showConfirmPassword"
        type="button"
      >
        <mat-icon>{{
          showConfirmPassword ? "visibility" : "visibility_off"
        }}</mat-icon>
      </button>
    </div>
  </div>
  <div class="errors mt-4 flex flex-col gap-2">
    <div
      id="lengthError"
      [class.error]="form.errors?.minLength"
      [class.success]="!form.errors?.minLength"
      class="flex flex-row justify-start gap-2 items-center"
    >
      <mat-icon *ngIf="form.errors?.minLength"
        >check_box_outline_blank</mat-icon
      >
      <mat-icon *ngIf="!form.errors?.minLength">check_box</mat-icon>
      <p>Password is at least 8 characters long</p>
    </div>
    <div
      id="mismatchError"
      [class.error]="form.errors?.passwordMismatch"
      [class.success]="!form.errors?.passwordMismatch"
      class="flex flex-row justify-start gap-2 items-center"
    >
      <mat-icon *ngIf="form.errors?.passwordMismatch"
        >check_box_outline_blank</mat-icon
      >
      <mat-icon *ngIf="!form.errors?.passwordMismatch">check_box</mat-icon>
      <p>Password and Confirm fields match</p>
    </div>
  </div>
</form>
